module.exports = "https://cdn.spacehpc.com/img/banner02-md.png";